"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports["default"]={start_scale:.1,end_scale:2,start_opacity:.2,end_opacity:0},module.exports=exports["default"];
//# sourceMappingURL=config.js.map